// extracted by mini-css-extract-plugin
export default {"form":"Wj1Dv3dSzXGIaGfwd4Zw","input":"ljb4TtY1ozdEasShkbPc","submit":"r03M61zbvohbvCi_QHc_"};